import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {getSchoolYear} from "../../../../utils/authority";
import StudentController from "../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
import DatePicker, {registerLocale} from "react-datepicker";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import BusRouteController from "../../../../services/system/bus/bus-route-controller";
import BusCheckController from "../../../../services/system/bus/bus-check-controller";
import {toast} from "react-toastify";
registerLocale("vi", vi);


class DetailBusReportAttendanceManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listRouteBus: [],
            busStopRes: [],
            listStudentCheck: [],
            dateReport: new Date(),
            busRouteId: -1,
            busStopId: -1,
            busUpDownType: "XUONG_XE",

            listData: [],
            listClass: [],
            pageNumber: 0,
            pageSize: 10,
            classRoomId: -1,
            gradeId: "",
            gender: "",
            code: "",
            ethnic: "",
            fullName: "",
            studentState: "",
            isShowText: false,
            sort: 'id',
            descending: 'DESC',
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Tên học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "startDate",
                    name: "Tài xế",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Phụ xe",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "payment",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "register",
                    name: "Lên xe",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "register",
                    name: "Xuống xe",
                    style: {textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this. getListRouteBus()
        this. getListStudentCheck()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListStudentCheck();
            }
        );
    };
    onhandleSearch() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: parseInt(this.state.classRoomId),
            code: this.state.code,
            ethnic: this.state.ethnic,
            fullName: this.state.fullName,
            gender: this.state.gender,
            grade: this.state.gradeId,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
            studentState: this.state.studentState,
        };
        StudentController.search(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "PENDING",
                "name": "Dừng hoạt động"
            },
            {
                "id": "ACTIVE",
                "name": "Đang hoạt động"
            },
            {
                "id": "DISABLE",
                "name": "Đã khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getListRouteBus() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            assistant1Name: "",
            busRouteName: "",
            driverName: "",
            pageNumber: 0,
            pageSize: 100,
            sort: "created_at desc",
            state: "ACTIVE",
        };
        BusRouteController.search(payload, res => {
            this.setState({
                showLoading: false,
                listRouteBus: res.data.content,
            });
        })
    }
    getListStudentCheck() {
        if (this.state.dateReport == null)
            this.state.dateReport = new Date()
        let day = this.state.dateReport.getDate();
        let month = this.state.dateReport.getMonth()+1;
        let year = this.state.dateReport.getFullYear();
        let payload = {
            yearId: parseInt(getSchoolYear()),
            busRouteId: parseInt(this.state.busRouteId),
            busStopId: parseInt(this.state.busStopId),
            busUpDownTypeStr: this.state.busUpDownType,
            day: day,
            month: month,
            year: year
        };
        BusCheckController.list(payload, res => {
            this.setState({
                showLoading: false,
                listStudentCheck: res.data,
            });
        })
    }
    getDetailRouteBusRegister(busId) {
        BusRouteController.detailRegister(busId, res => {
            if (res.success){
                this.setState({
                    busStopRes: res.data.busStopRes,
                })
            }else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }
        })
    }
    renderBusStop() {
        return this.state.busStopRes.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        let {listStudentCheck, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="report-bus" parentClass="bus-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                                <div className="content-loading col-12 ml-3 align-items-center"
                                     style={{display: 'block'}}>
                                    <div className="spinner-grow text-info"/>
                                </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Báo cáo điểm danh xe bus"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn tuyến xe bus</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listRouteBus}
                                                    getOptionLabel={option => option.name?option.name:"No Name"}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.routeBusName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên tuyến xe bus'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                routeBusName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.busRouteId = -1;
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.getDetailRouteBusRegister(val?.id)
                                                            this.setState({
                                                                busRouteId: val?.id,
                                                                routeBusName: val?.name,
                                                            }, ()=>{
                                                                this.getListStudentCheck()
                                                            })
                                                        }else {
                                                            this.setState({
                                                                busRouteId: -1,
                                                                routeBusName: "",
                                                            })
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn ngày</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.dateReport === '' ? null : new Date(this.state.dateReport)}
                                                    maxDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            try {
                                                                this.setState({
                                                                    dateReport: date,
                                                                }, ()=>{
                                                                    this.getListStudentCheck()
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn điểm đón xe bus</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.busStopId}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            busStopId: e.target.value
                                                        }, ()=>{
                                                            this.getListStudentCheck()
                                                        })
                                                    }}
                                                >
                                                    <option value="-1">Chọn điểm đón</option>
                                                    {this.renderBusStop()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Hình thức(Lên/Xuống)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.busUpDownType}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            busUpDownType: e.target.value
                                                        }, ()=>{
                                                            this.getListStudentCheck()
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn điểm đón</option>
                                                    <option value="LEN_XE">Lên xe</option>
                                                    <option value="XUONG_XE">Xuống xe</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm mr-2"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Lọc
                                                </button>
                                                <LinkPlus
                                                    style={{color: '#000'}}
                                                    to={{
                                                        pathname: "/ad-sas-school/chi-tiet-diem-danh-xe-bus",
                                                        state: {
                                                            fromDashboard: true,
                                                        }
                                                    }}
                                                >
                                                    <button
                                                        style={{height: 35, marginRight: 12}}
                                                        type="button"
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    >
                                                        UI Chi tiết điểm danh
                                                    </button>
                                                </LinkPlus>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listStudentCheck ||
                                                this.state.listStudentCheck.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listStudentCheck &&
                                                        listStudentCheck.length > 0 &&
                                                        listStudentCheck?.map((row, index) => (
                                                            <tr style={{height: 50}}>
                                                                <td style={{textAlign: "center"}} scope="row">
                                                                    {" "}
                                                                    {this.state.pageNumber * this.state.pageSize +
                                                                        index +
                                                                        1}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.fullName}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.driverName}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {row.assistant1Name}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {row.state=="INACTIVE" ? <span className="badge badge-danger" style={{color: "white"}}>Khóa</span> : <span className="badge badge-success" style={{color: "white"}}>Đi học</span>}
                                                                </td>
                                                                <td style={{textAlign: "left"}}>
                                                                    {row.timeDon}
                                                                </td>
                                                                <td style={{textAlign: "left"}}>
                                                                    {row.timeTra}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DetailBusReportAttendanceManagement;
